import { Injectable } from '@angular/core';
import {Http, Response} from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map'
import { HttpClient } from './http-client';
import { Subject } from 'rxjs/Subject';

@Injectable()
export class ConfiguracionService {

  constructor(private httpClient: HttpClient,
              private http: Http) {
  }

  setConfiguration(hours: string = '', neg_hours: string = '', payload: any[]) {
    return this.httpClient.post(`/api/user/set-configuration/${hours}/${neg_hours}`, payload)
      .map(( response: Response) => {
          return response;
      });
  }

  // pass no parameter to retrieve current user configuration
  getConfiguration(userId?: string) {
    userId = userId || localStorage.getItem('userId');
    return this.httpClient.get(`/api/user/get-configuration/${userId}`)
      .map(( response: Response) => {
          return response.json().ResponseData;
      });
  }

}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/services/configuracion-service.ts